import type { YardGateAppointmentStatus } from 'contracts/YardGate';
import { Colors, OrderStatusColor } from 'styles/constants';

export interface YardGateStatusVisual {
  label: string;
  color: string;
}

export const statusVisuals: Record<
  YardGateAppointmentStatus,
  YardGateStatusVisual
> = {
  PENDING: { label: 'Pendente', color: OrderStatusColor.Chegada },
  AWAITING_RELEASE: {
    label: 'Ag. Liberação',
    color: OrderStatusColor.Iniciado,
  },
  ENTRY_AUTHORIZED: { label: 'Lib. Entrada', color: Colors.Green },
  EXIT_AUTHORIZED: { label: 'Lib. Saída', color: Colors.Blue },
  CANCELLED: { label: 'Cancelada', color: OrderStatusColor.Cancelado },
  NO_SHOW: { label: 'No Show', color: OrderStatusColor.NoShow },
};

export const statusFilterOptions: Array<{
  value: YardGateAppointmentStatus;
  label: string;
  color: string;
}> = [
  {
    value: 'PENDING',
    label: 'Pendentes',
    color: statusVisuals.PENDING.color,
  },
  {
    value: 'AWAITING_RELEASE',
    label: statusVisuals.AWAITING_RELEASE.label,
    color: statusVisuals.AWAITING_RELEASE.color,
  },
  {
    value: 'ENTRY_AUTHORIZED',
    label: statusVisuals.ENTRY_AUTHORIZED.label,
    color: statusVisuals.ENTRY_AUTHORIZED.color,
  },
  {
    value: 'EXIT_AUTHORIZED',
    label: statusVisuals.EXIT_AUTHORIZED.label,
    color: statusVisuals.EXIT_AUTHORIZED.color,
  },
  {
    value: 'CANCELLED',
    label: statusVisuals.CANCELLED.label,
    color: statusVisuals.CANCELLED.color,
  },
  {
    value: 'NO_SHOW',
    label: statusVisuals.NO_SHOW.label,
    color: statusVisuals.NO_SHOW.color,
  },
];
